import { DB, Parser, Player } from "svga";
import event from "@/event";
export const db = new DB();

// 帝皇背景动画资源
const dihuang_bg_source = { key: "dihuang_bg", source_url: "/gift/dihuang.svga" };

// 公爵背景动画资源
const gongjue_bg_source = { key: "gongjue_bg", source_url: "/gift/gongjue.svga" };

// 骑士背景动画资源
const qishi_bg_source = { key: "qishi_bg", source_url: "/gift/qishi.svga" };

// 冰霜雄狮入场
const lion_in = { key: "lion_in", source_url: "/gift/lion_in.svga" };

// 冰霜雄狮待机
const lion_wait = { key: "lion_wait", source_url: "/gift/lion_wait.svga" };

// 豪气元龙入场
const long_in = { key: "long_in", source_url: "/gift/long_in.svga" };

// 豪气元龙待机
const long_wait = { key: "long_wait", source_url: "/gift/long_wait.svga" };

// 炙热火狐入场
const fox_in = { key: "fox_in", source_url: "/gift/fox_in.svga" };

// 炙热火狐待机
const fox_wait = { key: "fox_wait", source_url: "/gift/fox_wait.svga" };

export default {
  data() {
    return {
      playStatus: {},
      // 礼物特效动画队列
      animationQueue: JSON.parse(sessionStorage.getItem("animate-queue") || "[]"),
      // 贵族入场动画队列
      admissionQueue: [],
      // 当前播放的特效礼物动画信息
      currentPlaySvg: null,
      // 当前播放的特效礼物动画player
      currentSvgaPlayer: null,
      // 是否有 入场贵族 动画播放
      isPlayingAdmission: false,
      // 当前入场贵族
      currentPlayVip: { p1: null, p2: null, user: {} },
      // 普通礼物 队列
      normalGifts: [
        { count: 1, sender_name: "小幺鸡", gift_icon: "", sender: 345893 },
        { count: 1, sender_name: "小幺鸡", gift_icon: "", sender: 345893 },
        { count: 1, sender_name: "小幺鸡", gift_icon: "", sender: 345893 },
        { count: 1, sender_name: "小幺鸡", gift_icon: "", sender: 345893 },
      ],
    };
  },

  methods: {
    // 预加载贵族入场动画资源
    async preloadVipSource() {
      await this.preloadSvgSource(dihuang_bg_source);
      await this.preloadSvgSource(gongjue_bg_source);
      await this.preloadSvgSource(qishi_bg_source);
      await this.preloadSvgSource(lion_in);
      // await this.preloadSvgSource(lion_wait)
      await this.preloadSvgSource(long_in);
      // await this.preloadSvgSource(long_wait)
      await this.preloadSvgSource(fox_in);
      // await this.preloadSvgSource(fox_wait)
    },

    // 预加载svga 资源并存储在 indexDB
    async preloadSvgSource(item = { key: "", source_url: "" }) {
      const parser = new Parser({ isDisableImageBitmapShim: true });
      const { key, source_url } = item;
      try {
        let svga = await db.find(key);
        if (!svga) {
          svga = await parser.load(source_url);
          await db.insert(key, svga);
        }
      } catch (error) {
        console.log(error);
      }
    },

    // 移除特效动画队列中 指定的动画
    removeAnimation(giftMsg = {}) {
      if (!giftMsg) return false;
      this.animationQueue = this.animationQueue.filter((gift) => gift.add_time !== giftMsg.add_time);
    },

    addAnimation(giftMsg) {
      const gift = {
        add_time: performance.now().toString(),
        ...giftMsg,
      };
      this.animationQueue.push(gift);
    },

    clearAnimation() {
      this.animationQueue = [];
      if (this.giftTimer) {
        clearTimeout(this.giftTimer);
        this.giftTimer = null;
      }

      const flag = Object.values(this.playStatus).reduce((t, pre) => t || pre, false);

      // 如果有动画在播放中
      if (flag) {
        this.currentSvgaPlayer?.destroy();
        this.currentPlaySvg = null;
      }
    },

    // 播放动画容器
    createCanvas(id = "", styles = {}) {
      const canvas = document.createElement("canvas");
      const { width = 340, height, top, right, transform, position } = styles;

      const _width = Math.min(width, 340);
      const _height = width && height ? Math.floor(_width * (height / width)) : 0;
      let _top = top || "50%";
      const _right = right || "42px";
      const _transform = transform || `translate3d(0, -50%, 0)`;
      const _position = position || `fixed`;
      if(this.currentPlaySvg && this.currentPlaySvg.giftid && (this.currentPlaySvg.giftid==9 || this.currentPlaySvg.giftid==12)){
        _top = '40%'
      }
      console.log("styles====>", _width, _height, "right===", right, "_right===", _right);
      // 按比例缩放
      canvas.id = id;
      canvas.style.width = _width + "px";
      canvas.style.height = _height + "px";
      canvas.style.position = _position;
      canvas.style.zIndex = "999";
      canvas.style.top = _top;
      canvas.style.right = _right;
      canvas.style.transform = _transform;

      return canvas;
    },

    /**
     * 贵族入场头像与昵称
     * vipUser: {url: '', nickname: ''}
     * role 3 龙 2 狮 1 狐狸
     **/
    createVipInfo(vipUser = {}) {
      const div = document.createElement("div");
      div.style.position = "absolute";
      div.style.display = "flex";
      div.style.alignItems = "center";
      div.style.top = "44px";
      div.style.left = "44px";
      div.style.zIndex = "999";

      const welcomeTxt = {
        vip_1: "骑着炙热火狐驾临！",
        vip_2: "骑着冰霜雄狮驾临！",
        vip_3: "骑着豪气元龙驾临！",
      };
      div.innerHTML = `
        <div style="width: .32rem;height: .32rem;border-radius: 50%;padding: .02rem;overflow: hidden;background-image: url('/gift/avatar-border.png');background-size: 100% 100%;">
           <img style="width: 100%;height: 100%;border-radius: 50%;" src="${vipUser.avatar}">
        </div>
        
        <div style="margin-left: 5px;">
           <p style="font-size: .13rem;font-weight: 500;;color: #ffeb00;">${vipUser.client_name}</p>
           <span style="font-size: .1rem;font-weight: 500;color: #fff;">${welcomeTxt["vip_" + vipUser.vip_level]}</span>
        </div>
      `;
      return div;
    },

    createJoinRoomContainer(canvas, vipInfo) {
      const div = document.createElement("div");
      div.style.position = "fixed";
      div.style.zIndex = "999";
      div.id = "noble-animate";

      div.appendChild(canvas);
      div.appendChild(vipInfo);

      return div;
    },

    // 礼物特效动画
    async playSvga(animate = {}, callback = () => {}) {
      const parser = new Parser({ isDisableImageBitmapShim: true });
      const { animation, duration = 5000, id, style = {}, nextAnimate } = animate;

      const key = `gift_${id}`;
      const _key = `${key}_${Date.now()}`;
      let svga = await db.find(key);

      if (!svga) {
        svga = await parser.load(animation);
        await db.insert(key, svga);
      }

      const canvas = this.createCanvas(_key, { ...svga.size, ...style });

      document.body.appendChild(canvas);

      const player = new Player({
        // 播放动画的 Canvas 元素
        container: canvas,
        // 循环次数，默认值 0（无限循环）
        loop: 1,
        // 是否开启缓存已播放过的帧数据，默认值 false
        // 开启后对已绘制的帧进行缓存，提升重复播放动画性能
        isCacheFrames: false,
        // 是否开启动画容器视窗检测，默认值 false
        // 开启后利用 Intersection Observer API 检测动画容器是否处于视窗内，若处于视窗外，停止描绘渲染帧避免造成资源消耗
        // isUseIntersectionObserver: true,
        // 是否使用避免执行延迟，默认值 false
        // 开启后使用 `WebWorker` 确保动画按时执行（避免个别情况下浏览器延迟或停止执行动画任务）
        // isOpenNoExecutionDelay: true,
        // 停留在尾贞
        fillMode: "backwards",
      });

      await player.mount(svga);

      let startTime = 0;

      player.onStart = () => {
        startTime = Date.now();
        // 如果是贵族入场的动画 不统计
        if (!this.currentPlayVip.user.vip_level) {
          this.playStatus[_key] = true;
        }
      };

      player.onProcess = () => {
        if (Date.now() - startTime >= duration) {
          // parser?.destroy();
          // player?.destroy();
          delete this.playStatus[_key];
        }
      };

      player.onEnd = () => {
        console.log("player onEnd", canvas, canvas.id);

        if (canvas) {
          document.body.removeChild(canvas);
        }

        delete this.playStatus[_key];
        console.log("destroy---------------svga");
        parser?.destroy();
        player?.destroy();

        callback && callback();
      };

      player.onStop = () => {
        console.log("player onStop ====>");
        if (canvas) {
          document.body.removeChild(canvas);
        }
        delete this.playStatus[_key];

        callback && callback(player);
      };
      player.start();
      return player;
    },

    // 特效动画，不可重叠 一次播一条
    async playSvgaAnimation(index = 0) {
      // 2 判断是否有在播放中的动画
      const hasPlay = Object.values(this.playStatus).reduce((flag, v) => flag || v, false);
      console.log("是否有动画正在播放===", hasPlay, this.playStatus);

      // 如果有动画在播放中不做处理
      if (hasPlay) return;

      // 3 找出堆栈中 第一个
      this.currentPlaySvg = this.animationQueue[index];

      // 如果没有找到退出
      if (!this.currentPlaySvg) return;

      const gift = this.gifts[`gift_${this.currentPlaySvg.giftid}`];

      if (!gift) {
        this.removeAnimation(this.currentPlaySvg);
        return;
      }

      console.log("key", `gift_${this.currentPlaySvg.giftid}`, this.currentPlaySvg, this.gifts);
      console.log("即将播放的动画:", gift.title, "\nid:", gift.id, "\n是否加载完:", gift.loaded);

      if (this.giftTimer) {
        clearTimeout(this.giftTimer);
        this.giftTimer = null;
      }

      // 4 如果即将播放的动画 没有加载完，找下一个动画播放（间隔500ms）
      if (!gift.loaded) {
        this.giftTimer = setTimeout(() => {
          const _index = index + 1;
          const nextIndex = _index >= this.animationQueue.length ? 0 : _index;
          // event.$emit('animation', nextIndex)

          this.playSvgaAnimation(nextIndex);
        }, 500);
      } else {
        // 5 播放完毕
        this.currentSvgaPlayer = await this.playSvga(gift, () => {
          // 播放完毕 删掉 堆栈中的消息
          this.removeAnimation(this.currentPlaySvg);

          console.log("执行播放==", gift.title, "==完毕回调函数");
          // 寻找一下动画指针
          const _index = index + 1;
          const nextIndex = _index >= this.animationQueue.length ? 0 : _index;
          // event.$emit('animation', nextIndex)

          this.playSvgaAnimation(nextIndex);
        });
      }
    },

    // 动画和用户信息整合
    async playJoinRoomAnimation(animate = {}, callback = () => {}) {
      const parser = new Parser({ isDisableImageBitmapShim: true });
      const { animation, id, style = {} } = animate;

      let svga = await db.find(id);

      if (!svga) {
        svga = await parser.load(animation);
        await db.insert(id, svga);
      }

      const canvas = this.createCanvas(id, { ...svga.size, ...style });
      const vipInfo = this.createVipInfo(this.currentPlayVip.user);
      const container = this.createJoinRoomContainer(canvas, vipInfo);
      container.style.top = "24%";
      container.style.right = "160px";
      container.style.width = style.width + "px";
      container.style.height = style.height + "px";

      document.body.appendChild(container);

      const player = new Player({
        container: canvas,
        loop: 1,
        // isCacheFrames: true,
        // isUseIntersectionObserver: true,
        // isOpenNoExecutionDelay: true,
      });

      await player.mount(svga);

      player.start();

      // onEnd 会在 销毁后触发，
      player.onEnd = () => {
        this.isPlayingAdmission = false;
        console.log("player vip end");

        if (container) {
          document.body.removeChild(container);
        }
        parser.destroy();
        player.destroy();
        callback && callback();
      };

      // 暂停
      player.onStop = () => {
        console.log("player vip stop");
        if (container) {
          document.body.removeChild(container);
        }
        this.isPlayingAdmission = false;
        callback && callback();
      };

      return player;
    },

    // 添加到播放队列
    async addAdmissionAnimate(vipUser = {}) {
      console.log("addAdmissionAnimate=====>", vipUser);
      this.animationQueue.push(vipUser);

      await this.startQueueAnimate();
    },

    async startQueueAnimate() {
      if (this.isPlayingAdmission || this.animationQueue.length === 0 || !/^\/liveMatchesTwo\/\d/.test(this.$route.path)) {
        return false;
      }

      this.isPlayingAdmission = true;

      const playAnimate = this.animationQueue.shift();

      if (this.vipTimer) {
        clearTimeout(this.vipTimer);
        this.vipTimer = null;
      }

      await this.playVipAnimation(playAnimate, () => {
        this.vipTimer = setTimeout(() => {
          this.startQueueAnimate();
        }, 200);
      });
    },

    /**
     * 贵族入场动画
     * 1 帝皇 2 公爵 3 骑士
     * */
    async playVipAnimation(vipUser = { vip_level: 0 }, callback = () => {}) {
      const containerStyles = {
        position: "absolute",
        width: 240,
        height: 104,
        top: "0",
        right: "0",
        transform: "translate3d(0, 0, 0)",
      };

      const levelAnimate = {
        animation: long_in.source_url,
        id: long_in.key,
        duration: 20000,
        style: { width: 220, height: 220, top: "29%", right: "0" },
      };

      this.currentPlayVip.user = vipUser;

      switch (vipUser.vip_level) {
        case 3: // 帝皇
          const dihuangAnimate = {
            animation: dihuang_bg_source.source_url,
            duration: 20000,
            id: dihuang_bg_source.key,
            style: containerStyles,
          };
          this.currentPlayVip.p1 = await this.playJoinRoomAnimation(dihuangAnimate);

          this.currentPlayVip.p2 = await this.playSvga(levelAnimate, () => {
            // 播放完成之后 播放等待动画
            // this.currentPlayVip.p1?.stop();

            // 初始化
            this.currentPlayVip = { p1: null, p2: null, user: {} };
            callback && callback();
          });

          break;
        case 2: // 公爵
          const gongjueAnimate = {
            animation: gongjue_bg_source.source_url,
            duration: 20000,
            id: gongjue_bg_source.key,
            style: containerStyles,
          };

          this.currentPlayVip.p1 = await this.playJoinRoomAnimation(gongjueAnimate);

          levelAnimate.animation = lion_in.source_url;
          levelAnimate.id = lion_in.key;

          this.currentPlayVip.p2 = await this.playSvga(levelAnimate, () => {
            // 播放完成之后 关闭会员动画
            // this.currentPlayVip.p1?.stop();

            // 初始化
            this.currentPlayVip = { p1: null, p2: null, user: {} };
            callback && callback();
          });
          break;
        case 1: // 骑士
          const qishiAnimate = {
            animation: qishi_bg_source.source_url,
            duration: 20000,
            id: qishi_bg_source.key,
            style: containerStyles,
          };

          this.currentPlayVip.p1 = await this.playJoinRoomAnimation(qishiAnimate);

          levelAnimate.animation = fox_in.source_url;
          levelAnimate.id = fox_in.key;

          this.currentPlayVip.p2 = await this.playSvga(levelAnimate, () => {
            // 播放完成之后 播放等待动画
            // this.currentPlayVip.p1?.stop();

            // 初始化
            this.currentPlayVip = { p1: null, p2: null, user: {} };
            callback && callback();
          });
          break;
      }
    },

    clearJoinRoomAnimate() {
      this.animationQueue = [];
      this.$nextTick(() => {
        let node = document.getElementById("noble-animate");
        console.log("node==========", node);
        if (node) {
          document.body.removeChild(node);
        }
      });

      if (this.vipTimer) {
        clearTimeout(this.vipTimer);
        this.vipTimer = null;
      }

      if (this.currentPlayVip.p1) {
        // this.currentPlayVip.p1.stop()
        this.currentPlayVip.p1.destroy();
      }

      if (this.currentPlayVip.p2) {
        console.log("beforeDestroy========> this.currentPlayVip.p2");
        this.currentPlayVip.p2.destroy();
      }

      // 初始化
      this.currentPlayVip = { p1: null, p2: null, user: {} };
    },
  },

  created() {
    this.giftTimer = null;
    this.vipTimer = null;
  },

  beforeDestroy() {
    this.clearJoinRoomAnimate();
  },
};
